exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Section-module__section--2aKG2 {\r\n  margin-top: 8px;\r\n  border-top: 1px solid #cccccc;\r\n  border-bottom: 1px solid #cccccc;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n  box-sizing: border-box;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"section": "Section-module__section--2aKG2"
};